<template>
  <div v-if="refundInfo">
    <div class="refund-title">
      编号:
      <span>{{ refundInfo.guid }}</span>
    </div>
    <div v-if="optStatusLabel">
      退款状态:
      <span :class="optStatusClassName">{{ optStatusLabel }}</span>
    </div>
    <div v-if="refundInfo.createTime > 0">
      <span>
        创建时间:
        {{ new Date(refundInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div v-if="refundInfo.refundTradeNo">
      退款单号:
      <span>{{ refundInfo.refundTradeNo }}</span>
    </div>
    <div v-if="refundInfo.paymentGuid">
      支付编号:
      <span>{{ refundInfo.paymentGuid }}</span>
    </div>
    <div v-if="refundInfo.bizUniqueId">
      业务单号:
      <span>{{ refundInfo.bizUniqueId }}</span>
    </div>
    <div v-if="bizTypeLabel">
      业务类型:
      <span>{{ bizTypeLabel }}</span>
    </div>
    <div v-if="refundInfo.paymentType">
      退款方式:
      <span>{{ refundInfo.paymentType }}</span>
    </div>
    <div v-if="refundInfo.handledBy">
      经手人员:
      <span>{{ refundInfo.handledBy }}</span>
    </div>
    <div>
      退款金额:
      <span> {{ refundInfo.refundAmount || 0 }}元 </span>
    </div>
    <div v-if="refundInfo.refundReason">
      <div class="wordwrap">
        原因:
        <span class="refund-reason">{{ refundInfo.refundReason }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.refund-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}

.refund-reason {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.refund-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.refund-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;

  &.refunding {
    background-color: #3399ff;
    border: 1px solid #3399ff;
    color: #ffffff;
  }

  &.refund_error {
    background-color: #f56c6c;
    border: 1px solid #f56c6c;
    color: #ffffff;
  }

  &.refunded {
    background-color: #67c23a;
    border: 1px solid #67c23a;
    color: #ffffff;
  }
}
</style>

<script>
export default {
  props: {
    refundInfo: {
      type: Object
    }
  },
  methods: {
    refundListClick() {
      this.$emit('refundListClick', this.refundInfo)
    },
  },
  computed: {
    bizTypeLabel() {
      if (!this.refundInfo) {
        return '';
      }
      if (this.refundInfo.bizType === 'warehouse_order') {
        return '销售订单';
      }
      return this.refundInfo.bizType;
    },
    paymentTypeLabel() {
      if (!this.refundInfo) {
        return '';
      }
      if (this.refundInfo.paymentType === 'wepay') {
        return '微信';
      } else if (this.refundInfo.paymentType === 'alipay') {
        return '支付宝';
      }
      return this.refundInfo.paymentType;
    },
    optStatusClassName() {
      if (!this.refundInfo) {
        return '';
      }
      if (this.refundInfo.optStatus == 0) {
        return 'refund-status refunding';
      } else if (this.refundInfo.optStatus == 1) {
        return 'refund-status refund_error';
      } else if (this.refundInfo.optStatus == 2) {
        return 'refund-status refunded';
      }
      return '';
    },
    optStatusLabel() {
      if (!this.refundInfo) {
        return '';
      }
      if (this.refundInfo.optStatus == 0) {
        return '退款中';
      } else if (this.refundInfo.optStatus == 1) {
        return '退款失败';
      } else if (this.refundInfo.optStatus == 2) {
        return '退款成功';
      }
      return '';
    }
  }
}
</script>
